(()=>{
  const menu=document.querySelector('[data-mobile-menu]');
  const toggles=[...document.querySelectorAll('[data-menu-toggle]')];
  const sync=()=>{
    const open=!!menu?.classList.contains('is-open');
    menu?.setAttribute('aria-hidden',open?'false':'true');
    toggles.forEach(t=>t.setAttribute('aria-expanded',open?'true':'false'));
  };
  toggles.forEach(t=>t.addEventListener('click',()=>requestAnimationFrame(sync)));
  menu?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{
    menu.classList.remove('is-open');
    document.body.style.overflow='';
    sync();
  }));
  addEventListener('resize',()=>{
    if(innerWidth>989 && menu?.classList.contains('is-open')){
      menu.classList.remove('is-open');
      document.body.style.overflow='';
      sync();
    }
  },{passive:true});
  sync();
})();
